import request from '.';

function handle401Error() {
  // presumably the user's session expired
  // so just reload to send them to the login page
  window.location.reload();
}

export default function handleGenericAppErrors(err: unknown) {
  if (err instanceof request.RequestError) {
    // TODO: generic handler for 5xx error?
    switch (err.status) {
      case 401:
        handle401Error();
        break;
      default:
        break;
    }
  }
  return Promise.reject(err);
}
